module.exports = {
  siteMetadata: {
    title: '博彩策略研究院',
    shortTitle: '博彩策略',
    author: '成博士',
    description:
      '了解博彩的合理策略，探究赌博的必胜技巧，人工智能博彩策略，跟踪博彩行业最新资讯，网上娱乐平台推荐，机器学习，大数据分析，百家乐的玩法，彩票的规则，老虎机的数学，尽在博彩研究院。',
    keywords:
      '博彩，AI，人工智能，策略，行业资讯，博彩公司排名，百家乐，PK10，北京赛车，老虎机，轮盘赌，骰宝',
    siteUrl: 'https://www.slots188.com',
    siteLogo: '',
    siteRss: '/rss.xml',
    siteMap: '/sitemap.xml'
  },
  googleAnalyticsID: 'G-8B9M1HSRZM',
  GTM: {
    id: 'GTM-PH5TPW5'
  },
  AdSense: {
    client: 'ca-pub-2956392170416770'
  },
  disqusShortname: 'slots188',
  themeColor: '#dd4b39',
  backgroundColor: '#ffe6e3'
}
